export default __webpack_public_path__ + "static/media/gremlin-mascot.1c210690339e39daf0c6fefa8f229ca6.svg";